import axios from 'axios'

// Bootstrap instance axios and set defaults
const ibanHttpClient = axios.create({
  baseURL: 'https://openiban.com',
  timeout: 10000, // Timout 150 seconds
  headers: {
    'Content-Type': 'application/json'
  }
})

const common = {
  /* #############################################
#                 GET Entities                 #
############################################ */

  // GET * resource:  npos | donations | users | merchants | clients
  async validateIban (iban, data) {
    console.log('DATA', data)
    const response = await ibanHttpClient.get(`/validate/${iban}?validateBankCode=true&getBIC=true`, {
      params: data
    })
    return response.data
  }
}

export default {
  ...common
}

/* #########################################
#             Request interceptors         #
########################################## */

// The interceptor will add auth token
// httpClient.interceptors.request.use(function (req) {
//   const token = localStorage['x-token']
//   const tokenType = localStorage.token_type
//   if (token != null) {
//     req.headers.Authorization = `${tokenType} ${token}` // Add Token to every Call
//   }
//   return req
// }, function (err) {
//   return Promise.reject(err)
// })

/* #########################################
#            Response interceptors         #
########################################## */

// Add a 401 response interceptor
// httpClient.interceptors.response.use(function (response) {
//   return response
// }, function (error) {
//   if (error.response.status === 401) {
//     console.log('LOGOUT 401')
//     localStorage.clear()
//     store.dispatch('auth/logout')
//     // VueRouter.push({ name: 'login' })
//   }
//   return Promise.reject(error)
// })
